<template>
  <el-dialog
    title="Uzaktan Okuma Ekranı"
    :visible.sync="Durum"
    append-to-body
    width="70%">
    <Yukleniyor :data="lo"></Yukleniyor>
    <a @click="$emit('Durum', true)" class="ModalKapat"><i class="el-icon-close"></i></a>

    <el-row :gutter="24">
      <el-col :span="4">
        <h5 @click="CihazKontrol">Cihaz Bilgi</h5>
        <table class="table table-nohover table-xs">
          <tbody>

          <tr v-if="KisaDevre">
            <td class="bg-danger">
              <i class="feather-alert-triangle text-beyaz" style="font-size: 12px"></i> <b class="text-beyaz"> KISA
              DEVRE</b>
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block"> Cihaz Marka</small>
              <i class="feather-slack text-yesil" style="font-size: 12px"></i> {{ Data.ufirma }}
            </td>
          </tr>
          <tr>
            <td>
              <small class="d-block">Cihaz CCID/IMEI</small>
              <i class="feather-globe text-yesil" style="font-size: 12px"></i> {{ Data.ccid }}
            </td>
          </tr>
          <tr v-for="c in CihazBilgi" v-if="c.Data">
            <td>
              <small class="d-block">{{ c.Adi }}</small>
              <i :class="c.Ikon" class="text-yesil" style="font-size: 12px"></i> {{ c.Data }}
            </td>
          </tr>
          </tbody>
        </table>
        <el-alert
          v-if="OkumaDurumu"
          title="Okuma Devam Ediyor"
          type="error"
          :closable="false"
        >
        </el-alert>
      </el-col>
      <el-col :span="20">

        <h5>
          <el-button @click="OkumaYap('Stop','1')" size="mini" type="danger"
          >Okumayı Durdur
          </el-button>
          <!--el-button style="margin-top: -5px;margin-right: -5px" @click="SayacDurum()" size="mini" type="warning"
                     class="float-right">Yenile
          </el-button-->
          <el-button-group class="float-right">
            <el-button v-if="Data.ufirma=='Wimbus'" @click="Senkronize()"
                       size="mini" type="warning"
            >Seknronize Et
            </el-button>
            <el-button @click="OkumaYap('Hata','1')" size="mini" type="primary"
            >Hatalıları Oku
            </el-button>
            <el-button @click="OkumaYap('Kal','1')" size="mini" type="success"
            >Kalorimetre Oku
            </el-button>
            <el-button @click="OkumaYap('Sic','1')" size="mini" type="warning"
            >Sıcak Su Oku
            </el-button>
            <el-button @click="OkumaYap('Tum','1')" size="mini" type="info"
            >Tümünü Oku
            </el-button>
          </el-button-group>
        </h5>
        <div class="scrollkaydir" :style="'height: '+Height+'px'">
          <table class="table table-bordered table-xs table-nohover ">
            <thead>
            <tr>
              <th>Daire No</th>
              <th>Sayaç No</th>
              <th>Okunan Endeks</th>
              <th>Sayaç Üreticisi</th>
              <th>Giriş Sıcaklık</th>
              <th>Çıkış Sıcaklık</th>
              <th>Okuma Tarihi</th>
              <th>Okuma Durumu</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="s in SayacListe" @click="OkumaYap(s.id,s.OkumaDurumu)"
                :class="s.Class" style="cursor:pointer">
              <td>{{ s.kNo }}</td>
              <td>{{ s.SayacNo }}</td>
              <td>{{ s.SonEndeks }}</td>
              <td>{{ s.UreticiKodu }}</td>
              <td>{{ s.GSicaklik }}</td>
              <td>{{ s.CSicaklik }}</td>
              <td>{{ s.STarih }}</td>
              <td>{{ s.Durum }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </el-col>

    </el-row>

  </el-dialog>
</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ['Durum', 'Data'],
  data() {
    return {
      Height: window.innerHeight - 190,
      CihazBilgi: null,
      SayacListe: null,
      lo: false,
      OkumaKontrol: true,
      OkumaDurumu: false,
      KisaDevre: false
    }
  },
  methods: {
    CihazKontrol() {
      this.$store.dispatch("Get", {path: '_enerji/uo/' + this.Data.ufirma + '/cihaz/' + this.Data.ccid})
        .then(response => {
          this.CihazBilgi = response.Data
          this.KisaDevre = response.KisaDevre
        })
    },
    Senkronize() {
      this.lo = true
      this.$store.dispatch("Get", {path: '_enerji/uo/' + this.Data.ufirma + '/senkronize/' + this.Data.id})
        .then(response => {
          this.lo = false;
          this.CihazKontrol();
          this.SayacDurum();
        })
    },
    SayacDurum() {
      this.lo = true;
      this.$store.dispatch("Get", {path: '_enerji/uo/' + this.Data.ufirma + '/sayac/' + this.Data.id})
        .then(response => {
          this.lo = false;
          this.OkumaDurumu = response.Okuma
          this.SayacListe = response.Liste;
          if (response.Okuma && this.OkumaKontrol) {
            setTimeout(() => {
              this.rSayacDurum()
            }, 5000);
          } else {
            this.OkumaKontrol = false
          }
          this.Okuma = response.Okuma;
        })
    },
    rSayacDurum() {
      if (this.OkumaKontrol) this.SayacDurum();
    },
    OkumaYap(id, Durum) {

      if (Durum === '1') {
        this.lo = true;
        this.OkumaKontrol = true
        this.$store.dispatch("Get", {path: '_enerji/uo/' + this.Data.ufirma + '/okuma/' + this.Data.id + '/' + id})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.$message.success(response.Mesaj);
              this.SayacDurum();
            } else {
              this.$message.error(response.Mesaj);
            }
          })
      } else {
        this.$message.error("Sayaç zaten okunuyor");
      }

    },

  },
  created() {
    this.CihazKontrol();
    this.SayacDurum();
  },
  destroyed() {
    this.OkumaKontrol = false;
  }
}
</script>

<style scoped>
h5 {
  padding: 10px;
  background: #eceef6;
  font-size: 14px;
  margin: 0
}

</style>



// WEBPACK FOOTER //
// src/pages/_Sayac/Bina/UzaktanOkumaModal.vue